import React,{useEffect,useContext, useRef, useState} from 'react';
import { NavLink, Link, useLoaderData, useLocation} from "react-router-dom";
import ProgressiveImage from './ProgressiveImage/BackgroundImage';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';
import { ThemeContext } from '../context/ThemeContext';
import { useSwiper, Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';
import ColoredScrollbars from './ColoredScrollbars';
import { useHashScroll } from '../hooks/useHashScroll';
import TitleAnimated from './TitleAnimated';
import TitleAnimatedRotated from './TitleAnimatedRotated';
import ServicesHome from './ServicesHome';
import Contact from './Contact';

//import MinimalScrollTop from './MinimalScrollTop';
import 'swiper/css';
import 'swiper/css/virtual';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';



function Home(props) {

  const [swiperRef, setSwiperRef] = useState(null);
  const [imgHeight, setImgHeight] = useState(100);
  const [typeWriterScale, setTypeWriterScale] = useState(2);
  const [currentHash, setCurrentHash] = useState('');
  const scrollRef_1 = useRef(null);
  const scrollRef_2 = useRef(null);

  const titleRef = useRef();

  //console.log(props);
  let projectsData = useLoaderData();
  let projectsCineFeat = projectsData.items['cineFeat'];
  let projectsCine = projectsData.items['cine'];
  let projectsTv = projectsData.items['tv'];
  let projectsDoc = projectsData.items['doc'];
  let news = projectsData.items['news'];
  //console.log(projectsData.items);

  const shuffledProjects = [...projectsCineFeat].sort(() => Math.random() - 0.5);


  const theme = useContext(ThemeContext);
//console.log(theme.state);

const location = useLocation();

useEffect(() => {
if (location.hash) {
  setTimeout(() => {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100); // small delay to allow DOM render
}
}, [location]);

useEffect(()=> {
  // force 100% height
  if(theme.state.vertical && imgHeight != 80 ){
  setImgHeight(80);
  setTypeWriterScale(1.8);
  //console.log('switching vert.')
  }
},[theme.state.vertical])


  return (
<section className={"pt-0 " + props.transition}>
<div className="relative">
<Swiper
      onSwiper={setSwiperRef}
      className="mySwiper"

      modules={[Pagination, Navigation, EffectFade, Autoplay]}
      spaceBetween={0}
      centeredSlides={true}
      speed={800}
      //initialSlide={projectsCineFeat.length} 
       /* autoplay={{
          delay: 4000,
          disableOnInteraction: true,
        }}*/
        //waitForTransition
        pagination={{
          clickable: true,
        }}
      loop={true}
      slidesPerView={1}
      effect={'fade'}
      navigation={true}
      onSlideChange={(swiper) => {
      
        swiper.slides[swiper.activeIndex].classList.remove('opacity-0');
        swiper.slides[swiper.activeIndex].classList.add('opacity-100');

      // Pause all videos first
  swiper.el.querySelectorAll('video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });

  // Play video in active slide if it's a video slide (first 3 slides)
  if (swiper.activeIndex < 3) {
    const activeSlideEl = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlideEl.querySelector('video');
    if (activeVideo) {
      activeVideo.play().catch(e => console.log('Video play failed:', e));
    }
  }

        // Hide all logos
      swiper.el.querySelectorAll('.project-logo').forEach((logo) => {
        logo.classList.remove('opacity-100', 'pl-6');
        logo.classList.add('opacity-0', 'pl-0');
      });

      // Reveal the active one
      const activeSlideEl = swiper.slides[swiper.activeIndex];
      const activeLogo = activeSlideEl.querySelector('.project-logo');

      if (activeLogo) {
        // Force reflow to restart animation if needed
        void activeLogo.offsetWidth;

        activeLogo.classList.remove('opacity-0', 'pl-6');
        activeLogo.classList.add('opacity-100', 'pl-6');
      }

        if (titleRef.current) {
        //titleRef.current.stopRotation();
  }
    }}

    
      //onSwiper={(swiper) => console.log(swiper.activeIndex)}
    >

      {['/video/intro-2.mp4', '/video/intro-3.mp4'].map((videoSrc, index) => (
  <SwiperSlide className="opacity-0" key={`video-intro-${index + 1}`}>
    <div className="w-full h-full relative">
      <video 
        ref={(el) => {
          // Store video references for slide change control
          if (el) {
            el.dataset.videoIndex = index;
          }
        }}
        className="w-full h-full object-cover"
        style={{ 
        height: `${imgHeight}vh`,
        objectPosition: 'right center'
        }}
        poster={index === 0 ? "/video/intro-poster.jpg" : undefined}
        className="w-full h-full object-cover"
        autoPlay={index === 0} // Only first video autoplays
        muted 
        loop 
        playsInline
        preload="metadata"
        controls={false}
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        style={{ height: `${imgHeight}vh` }}
        onLoadStart={(e) => {
          // Force play on iOS when loaded - only for first video
          if (index === 0) {
            e.target.play().catch(error => console.log('Autoplay prevented:', error));
          }
        }}
        onCanPlay={(e) => {
          // Ensure video plays as soon as it can - only for first video
          if (index === 0) {
            e.target.play().catch(err => console.log('Play failed:', err));
          }
        }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      {/* Add the gradient overlay */}
      <div className="absolute bottom-0 left-0 w-full h-[28%] bg-gradient-to-t from-zinc-900 to-transparent pointer-events-none"></div>
    </div>
  </SwiperSlide>
))}





      {shuffledProjects.length > 0 ? shuffledProjects.map((project,index) => (
      index < 10 ?

      <SwiperSlide className="opacity-0" key={'cine-'+ index}>
        <div style={{}} className="w-full flex flex-col items-center p-0 space-y-3 text-center">

        <picture style={{overflow:'hidden'}} id={'btn-' + index} className="link">
        <ProgressiveImage
        src={project.image_bg_thumb.url}
        placeHolder={'/img/trans.gif'}
        modal={theme.modal}
        bg={'#333'}
        imgMargin={0}
        imgWidth={100}
        imgHeight={imgHeight}
        backgroundPosition={'center center'}
        />
               <div className="absolute bottom-0 left-0 w-full h-[28%] bg-gradient-to-t from-zinc-900 to-transparent pointer-events-none z-5"></div>

        </picture>

      
        {/* project.image_logo ?
        <div style={{transform: 'translateZ(0)', transition: 'padding 1s ease, opacity 0.8s ease'}} className={"fadeIn absolute bottom-12 md:bottom-18 left-0 md:left-2 text-white opacity-0 pl-6 transform transition-all duration-500 delay-200  z-10 ease-out project-logo project-logo-" + index }><img className="w-[200px] md:w-[480px]" src={project.image_logo} alt="item.logo"/></div>
        : '' */}
     
        </div>
    </SwiperSlide>

       : ''     ))  : ''}
     </Swiper>
<div style={{transform: 'translateZ(0)', transition: 'padding 1s ease, opacity 0.8s ease'}} className={"fadeIn absolute bottom-12 md:bottom-18 left-0 md:left-2 text-white opacity-0 pl-6 transform transition-all duration-500 delay-200  z-10 ease-out project-logo project-logo-vid" }>
     <TitleAnimatedRotated
      forwardedRef={titleRef}
      level={1}
      id_t={'project_title_rotated'}
      classes={'notranslate proj-title-rotated text-left  roboto-bold pt-6  pb-6 pl-2 text-8xl leading-6*2'}
      letterSpeed={0.01}
      scale={typeWriterScale}
      color="#fff"
      title={[
      '/ VFX',
'/ DI',
'/ CGI',
'/ SFX',
'/ COMP.',
'/ ROTO.',
'/ AAF',
'/ EDL',
'/ OMF',
'/ XML',
'/ MXF',
'/ LUT',
'/ HDR',
'/ SDR',
'/ DNR',
'/ CC',
'/ ADR',
'/ M&E',
'/ DCP',
'/ QC',
'/ TC',
'/ LTC',
'/ VITC',
'/ BPM',
'/ EQ',
'/ FX',
'/ GFX',
'/ MoGraph',
'/ CG',
'/ 2D',
'/ 3D',
'/ VR',
'/ AR',
'/ HDV',
'/ UHD',
'/ 4K',
'/ 8K',
'/ RGB',
'/ YUV',
      '',
 ]}
      afterTitle={false}
      />
          </div>
          <div style={{transform: 'translateZ(0)', transition: 'padding 1s ease, opacity 0.8s ease'}} className={"fadeIn absolute left-[3vw] bottom-[30%] md:bottom-[60%] text-8xl text-white opacity-0 pl-6 transform transition-all duration-500 delay-200  z-10 ease-out" }>
            <TitleAnimated
      level={1}
      id_t={'project_title'}
      classes={'notranslate proj-title text-left  roboto-bold pt-6  lg:pt-31 xl:pt-80 pb-4 pl-8 text-6xl leading-6*2'}
      letterSpeed={0.02}
      scale={1.0}
      color="white"
      title={'POST PRODUCTION STUDIO'}
      afterTitle={false}
      />
            
            </div>


          </div>

  {/*   <button onClick={() => swiperRef.slideNext()}>Slide to the next slide</button>
     <button onClick={() => swiperRef.slidePrev()}>Slide to the prev slide</button>
     */}

  {/*
    <div className="text-center p-4 mb-4 space-x-0 md:space-x-2 md:mb-8">
         <NavLink to="./cine" className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-magenta rounded-xl sm:w-auto sm:mb-0">
             Ver m&aacute;s CINE
             <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
           </NavLink>
     </div>
     */}








       

       {/* PROYECTOS */}
       <div className="pl-3 md:pl-10">
         <div id="proyectos" className="grid grid-cols-2 gap-1 py-4 pt-8">
           <div className="flex items-end justify-start">
             <h2 style={{fontSize:'2em'}} className="sectionHeader text-8xl font-medium text-left px-2.5 text-white pb-1">
               PROYECTOS
             
             </h2>
         </div>
        {/*    <div className="text-white flex items-end justify-end">
             <NavLink style={{paddingBottom:9+'px'}} to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
                 + Cine
               </NavLink>
         </div>
          */}
         </div>
        
      

       <div className="w-full py-0 bg-zinc-900 center relative">
               <div className="overflow-x-auto whitespace-nowrap py-2">
                 <ColoredScrollbars className="scrollDarkBg" style={{ height: 520 }}>
                 {projectsCine.length > 0 ? projectsCine.map((project,index) => (
                 index < 20 ?

                 <div className={'grow inline-block w-[280px] text-white  mx-1 items-center justify-center text-md font-medium grow-cine-' + index} key={'doc-'+ index}>

                     <a className="w-full" href={'https://frankariza.com/cine/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

                     <picture id={'btn-cine-' + index} className="link">
                     <ProgressiveImageImg
                     src={project.image_thumb.url}
                     placeholder={'/static/trans.gif'}
                     modal={theme.modal}
                     bg={'#333'}
                     imgMargin={props.imgMargin}
                     />
                     </picture>

                     <div className="flex flex-col p-1 space-y-1 text-left text-white">
                         <p style={{fontSize:110+'%'}} className="notranslate font-medium pb-2 pt-3 text-wrap">{project.name}</p>
                     </div>

                   </a>

                 </div>

                  : ''     ))  : ''}
              </ColoredScrollbars>
               </div>
              {/* <div className="text-center px-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-white">
                 <NavLink to="./cine"state={{ from: 'home', backLink:'cine' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
                     Ver m&aacute;s Cine
                     <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                   </NavLink>
               </div> */}
               <button className="ml-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.scrollLightBg .view');
                if (view) {
                    view.scrollBy({ left: -_w, behavior: 'smooth' });
                }
               }
             } className="button-prev text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                 </svg>
               </button>

               <button className="mr-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.scrollDarkBg .view');
                if (view) {
                    view.scrollBy({ left: _w, behavior: 'smooth' });
                }
               }
             } className="button-next text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                 </svg>
               </button>
       </div>
</div>


 <div className="pl-3 md:pl-10 w-full fadeIn">
         <div id="servicios" className="grid grid-cols-2 gap-1 py-4 pt-8">
           <div className="flex items-end justify-start">
             <h2 style={{fontSize:'2em'}} className="sectionHeader text-8xl font-medium text-left px-2.5 text-white pb-1">
               SERVICIOS
             </h2>
             

         </div>
        {/*    <div className="text-white flex items-end justify-end">
             <NavLink style={{paddingBottom:9+'px'}} to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
                 + Cine
               </NavLink>
         </div>
          */}
         </div>
         <ServicesHome/>
         </div>

{/* Contact */}
<div style={{background: 'linear-gradient(to bottom, rgba(167, 173, 39, 0.80), transparent)'}} className="py-16 opacity-0 fadeIn">
<Contact/>
</div>

{/* News */}


</section>

  )
}

export default Home
